const otherConstants =
{
    "ADD_TO_CART": "Add something to the cart as cart is Empty",
    "DISPLAY_CARD": "Card",
    "DISPLAY_CART": "Cart",
    "WORKING_ON_IT": "oops we are still working on it , hold on!!",
    "BUTTON_TYPE": "warning",
    "TRASH_BTN": "fas fa-trash-alt",
    "ADD_BTN": "fa fa-plus",
    "CUSTOM_ICON": "fas fa-pepper-hot",
    "BASE_PRICE": "Base Price Rs.",
    "SUB_TOTAL": "Subtotal Rs.",
    "SIZE_SMALL": "small",
    "SIZE_MEDIUM": "medium",
    "SIZE_LARGE": "large",
    "BROWN_BREAD_CRUST": "Brown Bread",
    "NEW_HAND_TOSSED_CRUST": "New Hand Tossed",
    "OREGANO_CRUST": "Oregano",
    "THICK_CRUST": "Thick Crust",
    "TOMATO_TOPPING": "tomato",
    "ONION_TOPPING": "onion",
    "CHEESE_TOPPING": "cheese",
    "CAPSICUM_TOPPING": "capsicum",
    "JALAPENO_TOPPING": "jalapeno",
    "CROSS_ICON": "fas fa-times",
    "CROSS_CODE": 27,
    "CHECKBOX_INPUT": "checkbox",
    "DROPDOWN_SIZE": "Size",
    "DROPDOWN_CRUST": "Crust",
    "NOT_AVAILABLE": "not available",
    "TOMATO_IMG": "https://images.dominos.co.in/toppingsTomato.jpg",
    "CAPSICUM_IMG": "https://images.dominos.co.in/toppingsCapsicum.jpg",
    "JALAPENO_IMG": "https://images.dominos.co.in/toppingsJalapeno.jpg",
    "ONION_IMG": "https://images.dominos.co.in/toppingsOnion.jpg",
    "ADD_CUSTOMIZATION": "Add Customizations",
    "ADD_CHEESE": "Add Cheese",
    "DELETE_CUSTOMIZATION": "Delete Customization",
    "SELECT_SIZE": "Size",
    "SELECT_CRUST": "Crust",
    "YOUR_CUSTOMIZATIONS": "Customizations :",
    "ADD_ITEMS": "Add To Cart",
    "CUSTOMIZED": "Customized",
    "NOTE": "Note :",
    "USER_NOTE": "Cost For Customizations Will Be Added In The Cart",
    "CART": "Cart",
    "TIME_OUT": "5000",
    "TOPPING_COST": 60,
    "EXTRA_COST": 15,
    "ORDER_TOTAL": "Order Total Rs.",
    "ADD_CHEESE_COST": "Add Extra Cheese(Rs.75)",
    "ADD_VEG_TOPPINGS": "Add Veg Toppings (Each Rs.60)",
    "PIZZA_DESC": "Loaded with Plant Based Protein topping along with Black Olives & Red Paprika enjoy this unique 100% Vegetarian pizza with a 100% Chicken like taste!",
    "PIZZA_IMG": "https://images.dominos.co.in/PIZ0167.jpg",
    "PIZZA_NAME": "The Unthinkable Pizza",
    "PIZZA_BASE_COST": 520,
    "COST_SMALL": 300,
    "COST_MEDIUM": 400,
    "COST_LARGE": 600,
    "BROWN_BREAD_COST": 30,
    "THICK_CRUST_COST": 60,
    "OREGANO_COST": 100,
    "NEW_HAND_TOSSED_COST": 120,
    "PIZZA_SLICE_NAME": "pizza",
    "CART_SLICE_NAME": "cart",
    "MODAL_SLICE_NAME": "modal"
};


export default Object.freeze( otherConstants );